import React from 'react';
import SelectComponent from "../../select/select-component.jsx";
import {translate} from "../../translate/translate.jsx";

const MonthYearInput = ({ filters, setFilters, hasMonth = true, hasYear = true, hasFutureYears = false, range = 20 }) => {

    const yearsOption = (limit = range) => {
        const currentYear = new Date().getFullYear();
        const past = limit;
        const future = hasFutureYears ? (limit/2) : 0;

        return Array.from(
            { length: past + future + 1 },
            (_, index) => ({
                label: (currentYear - past + index).toString(),
                value: (currentYear - past + index).toString()
            })
        ).reverse();
    };

    const monthOptions = Array.from({ length: 12 }, (_, index) => {
        const value = String(index + 1).padStart(2, "0");

        return {
            label: translate(value),
            value,
        };
    });

    return (
        <>

            <div className="flex gap-2">
                { hasMonth === true && (
                    <SelectComponent
                        id="month"
                        label='Mês *'
                        isMulti={false}
                        wrapValues={true}
                        options={monthOptions}
                        value={filters.month}
                        onChange={(value) => setFilters(prev => ({...prev, month: value}))}
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />
                )}

                { hasYear === true && (
                    <SelectComponent
                        id="year"
                        label="Ano *"
                        isMulti={false}
                        wrapValues={true}
                        options={yearsOption()}
                        value={filters.year}
                        onChange={(value) => setFilters(prev => ({...prev, year: value}))}
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />
                )}
            </div>

        </>
    );
};

export default MonthYearInput;